import { PageFrame } from '@lsy-netline/netline-ui';
import React from 'react';

import { ReactComponent as SessionExpiredSvg } from 'assets/session-expired.svg';
import { usePlatform } from 'hooks';

import AppHeader from '../AppHeader/AppHeader';
import ErrorView from '../ErrorView/ErrorView';

const handleLogin = () => {
  window.location.reload();
};

const SessionExpiredPage = () => {
  const platformConfig = usePlatform();

  return (
    <PageFrame header={platformConfig.hideAppHeader ? <div /> : <AppHeader />} data-testid="SessionExpired-root">
      <ErrorView
        logo={SessionExpiredSvg}
        title="session_expired.title"
        message="session_expired.message"
        actions={[
          {
            id: 'sign-in',
            text: 'session_expired.sing_in',
            onClick: handleLogin,
          },
        ]}
      />
    </PageFrame>
  );
};

export default SessionExpiredPage;
